import React, { useEffect, useRef, useState } from "react";

/** Fades its children up the first time they scroll into view. */
export default function Reveal({ children, delay = 0, className = "", as: Tag = "div" }) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const el = ref.current;
        if (!el || !("IntersectionObserver" in window)) { setVisible(true); return; }
        const io = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) { setVisible(true); io.disconnect(); }
        }, { threshold: 0.15 });
        io.observe(el);
        return () => io.disconnect();
    }, []);
    return (
        <Tag ref={ref} className={`reveal ${visible ? "is-visible" : ""} ${className}`} style={{ transitionDelay: `${delay}ms` }}>
            {children}
        </Tag>
    );
}
